import { render, staticRenderFns } from "./Autorizacao.vue?vue&type=template&id=319bdd12"
import script from "./Autorizacao.vue?vue&type=script&lang=js"
export * from "./Autorizacao.vue?vue&type=script&lang=js"
import style0 from "./Autorizacao.vue?vue&type=style&index=0&id=319bdd12&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports